// extracted by mini-css-extract-plugin
export var label = "_dt-1";
export var reminder = "_dt-0";